import { SECONDS_OF_HOUR } from './time';
import { getGlobalData } from './global';

export const isServer = (): boolean => {
  return !(
    typeof window === 'object' &&
    window &&
    typeof document !== 'undefined'
  );
};
// 过期时间
export const OVER_TIME = 'Mon, 26 Jul 1997 05:00:00 GMT';
export const ZH_REG = /[\u4e00-\u9fa5]/;

export const getCookies = () => {
  if (typeof document === 'undefined') {
    return getGlobalData().request?.cookies || {};
  }

  const cookies: {
    // tslint:disable-next-line: readonly-keyword
    [key: string]: string;
  } = {};

  document.cookie.split(/\s*;\s*/).forEach((pair) => {
    const split = pair.split(/\s*=\s*/);
    cookies[split[0]] = split.splice(1).join('=');
  });
  return cookies;
};

export const getRawValue = () => {
  return document.cookie;
};

/**
 * 获取cookie
 */
export const getCookie = (k: string) => {
  if (typeof document === 'undefined') {
    return getGlobalData().request?.cookies?.[k];
  }

  const cookieReg = new RegExp(`(^| )${k}=([^;]*)(;|$)`);
  const matches = document.cookie.match(cookieReg);

  return !matches ? '' : decodeURIComponent(matches[2]);
};

/**
 * 存储cookie
 */
export const setCookie = (
  k: string,
  v: any,
  domain?: string,
  path?: string,
  hour?: number
) => {
  const ts = Date.now() + SECONDS_OF_HOUR * (hour || 0);
  const expireKV = hour ? `; expires=${new Date(ts).toUTCString()}` : '';
  const pathKV = ` path=${path || '/'}`;
  const domainKV = domain ? ` domain=${domain};` : '';
  document.cookie = `${k}=${v}${expireKV};${pathKV};${domainKV}`;

  // 如果设置的cookie包含中文，则处理上报
  if (ZH_REG.test(v)) {
    console.info(`【Cookie中文检测】SET_COOKIE [${k} = ${v}]`);
  }
};

export const delCookie = (k: string, domain?: string, path?: string) => {
  if (isServer()) {
    return;
  }

  document.cookie = `${k}=; expires=${OVER_TIME}; path=${path || '/'}; ${domain ? `domain=${domain};` : ''
    }`;
};

export const clearCookie = () => {
  const rs = document.cookie.match(
    new RegExp('([^ ;][^;]*)(?=(=[^;]*)(;|$))', 'gi')
  );
  if (!rs) {
    return;
  }
  rs.forEach((item) => {
    document.cookie = `${item}=;expires=${OVER_TIME}; path=/; `;
  });
};

export const clearZhCookie = () => {
  const cookies = getCookies();

  Object.keys(cookies)
    .filter((key) => {
      return ZH_REG.test(cookies[key]);
    })
    .forEach((key) => {
      delCookie(key);
    });
};

/**
 * 上报页面带中文字符的cookie内容
 */
export const pageReportZhCookie = () => {
  const cookies = getCookies();

  const zhCookieKeys = Object.keys(cookies).filter((key) => {
    return ZH_REG.test(cookies[key]);
  });

  if (zhCookieKeys.length) {
    const info = zhCookieKeys
      .map((key) => `${key} = ${cookies[key]}`)
      .join(', ');
    console.error(`【Cookie中文检测】PAGE_REPORT [${info}]`);
  }
};

/**
 * 上报页面带中文字符的cookie内容
 */
export const pageReportZhCookieForKV = (k: string, v: string) => {
  if (ZH_REG.test(v)) {
    console.error(`【Cookie中文检测】PAGE_REPORT [${k}=${v}]`);
  }
};
